export default "__VITE_ASSET__7a84ed08__"